import React from 'react';
import { PropTypes } from 'prop-types';
import { useSelector } from 'react-redux';

import {
  ListItem,
  ListItemButton,
  Stack,
  Typography,
  Divider as ListDivider,
  Grid,
} from '@mui/material';

import AvatarWithStatus from './AvatarWithStatus';
import { formatTimestamp } from 'app/helpers/timestampHelpers';
import useChatFunctions from '../hooks/useChatFunctions';

const ContactListItem = ({ contact }) => {
  const { setCurrentContactBySlug } = useChatFunctions();

  const currentContact = useSelector((state) => {
    return state.nfChat.currentContact;
  });

  const selected = currentContact?.id === contact?.id;

  return (
    <>
      <ListItem
        sx={{
          padding: 0,
          margin: 0,
          width: '100%',
        }}
      >
        <ListItemButton
          onClick={() => {
            setCurrentContactBySlug(contact.other_user.slug);
          }}
          color="neutral"
          sx={{
            flexDirection: 'column',
            alignItems: 'initial',
            gap: 0,
            padding: 1,
            backgroundColor: selected ? 'rgb(245, 245, 254)' : 'inherit',
          }}
        >
          <Grid container>
            <Grid item xs={2}>
              <AvatarWithStatus contact={contact} />
            </Grid>
            <Grid item xs={10}>
              <Stack direction="column" sx={{ paddingLeft: 1 }}>
                <Stack direction="row" sx={{ justifyContent: 'space-between' }}>
                  <Typography
                    sx={{
                      fontSize: '1.063em',
                      fontWeight: contact.unread_messages ? 'bold' : 'normal',
                    }}
                  >
                    {contact.other_user.name}
                  </Typography>
                  <Typography
                    variant="body2"
                    noWrap
                    sx={{
                      textAlign: 'right',
                      display: {
                        xs: 'none',
                        md: 'block',
                      },
                    }}
                  >
                    {formatTimestamp(contact.last_activity_at)}
                  </Typography>
                </Stack>
                <Typography
                  variant="body3"
                  sx={{
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                  }}
                >
                  {contact.last_message_content}
                </Typography>
              </Stack>
            </Grid>
          </Grid>
        </ListItemButton>
      </ListItem>
      <ListDivider sx={{ margin: 0 }} />
    </>
  );
};

ContactListItem.propTypes = {
  contact: PropTypes.object.isRequired,
};

export default ContactListItem;
